import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const Message = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M17 18.4301H13L8.54999 21.39C7.88999 21.83 7 21.3601 7 20.5601V18.4301C4 18.4301 2 16.4301 2 13.4301V7.42999C2 4.42999 4 2.42999 7 2.42999H17C20 2.42999 22 4.42999 22 7.42999V13.4301C22 16.4301 20 18.4301 17 18.4301Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "8",
                cy: "10.5",
                r: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "12",
                cy: "10.5",
                r: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("circle", {
                cx: "16",
                cy: "10.5",
                r: "1",
                fill: "currentColor"
            })
        ]
    });
